/// <amd-module name="VSS/Redux/StoreService" />
import { Services, VssService, IVssService } from "VSS/Platform/Context";
import { IModuleStore } from "redux-dynamic-modules";

export interface IReduxStoreService extends IVssService {
    getStore: (createStore: () => IModuleStore<any>) => IModuleStore<any>;
    setStore: (store: IModuleStore<any>) => void;
}

class ReduxStoreService extends VssService implements IReduxStoreService {
    private store: IModuleStore<any>;

    public getStore(createStore: () => IModuleStore<any>) {
        if (!this.store) {
            this.store = createStore();
        }
        return this.store;
    }

    public setStore(store: IModuleStore<any>) {
        this.store = store;
    }
}

Services.add("redux-store-service", { serviceFactory: ReduxStoreService });
